<template>
  <div 
    id="app" 
    :class="{
      desktop: showTitleBar, 
      'setting-overlay': showOverlaySetter,
      'login-page': $route.name === 'login'
    }"
    @contextmenu.prevent="preventDefaultContextMenu"
  >
    <router-view />
    <transition name="viewer-fade">
      <ImgPreviewer 
        v-if="imgPreviewer.show" 
        :initialIndex="imgPreviewer.initialIndex" 
        :urlList="imgPreviewer.urlList"
        :isLongImg="imgPreviewer.isLongImg"
        @close="imgPreviewerClose"
      ></ImgPreviewer>
    </transition>
  </div>
</template>

<script>
import EventBus from '_lib/EventBus';
import { mapActions, mapMutations, mapGetters } from "vuex";
import { getUpdateUrl, getCurrentVersionLog } from '_api/update';
import { compareVersions, getStorage, setStorage, getMachineId, getOSType, delStorage } from '_lib/utils/utils'
import { playAudio } from '_lib/utils/utilsMedia';
const ImgPreviewer = () => import('@/ChatUI/packages/img/components/previewer.vue');

export default {
  components: {
    ImgPreviewer
  },
  data() {
    return {
      updateInfo: null,
      init_auto_update_asar: 1,
      imgPreviewer: {
        show: false,
        initialIndex: 0,
        urlList: []
      },
      asar_version: '',
      showOverlaySetter: false,
      rollBackCount: 0,
    }
  },
  created() {
    if (!process.env.IS_CLIENT) {
      const osType = getOSType()
      const pathname = window.location.pathname;
      const isValidInvitePath = pathname.startsWith('/i') || pathname.startsWith('/j')
      
      if (['iOS', 'Android'].includes(osType) && !isValidInvitePath) {
        window.location.replace('https://chat.xiaoheihe.cn/home/mobile')
      }
    }
    this.initElectronCb()
    this.initMachineId()
  },
  computed: {
    showTitleBar() {
      return process.env.IS_CLIENT || (!!this.$route.matched.find((v => v.name === 'main')))
    },
    ...mapGetters([
      'show_theme_data',
      'auto_update_asar',
      'cur_channel_data',
      'setting_data',
      'match_params',
      'tip_sound_volume',
      'tip_sound_control'
    ])
  },
  mounted() {
    document.addEventListener('mouseup', (e) => {
      if (e.button === 3 || e.button === 4) {
        e.preventDefault();
      }
    })
    if (process.env.IS_CLIENT && window.electronAPI) {
      this.setReport()
    }

    this.bindEvent()
  },
  watch: {
    auto_update_asar (v, o) {
      if (o === undefined && !this.updateInfo) {
        this.init_auto_update_asar = v
        this.getUpdateUrl()
      }
    }
  },
  methods: {
    initElectronCb() {
      if (process.env.IS_CLIENT && window.electronAPI) {
        window.electronAPI.refreshData((_, k, v) => {
          if (k === 'hcsd') {
            this.$rtc.initSetting(v)
          } else if (k === 'user_account_settings') {
            this.SET_USER_ACCOUNT_SETTINGS(v)
          }
        })
        window.electronAPI.executeProtocol((_, p) => {
          this.$protocol(p)
        })
        window.electronAPI.protocolListenerReady()
        window.electronAPI.pollingTeamListUpdate((_, p) => {
          EventBus.$emit('POLLING_TEAM_LIST_UPDATE', p);
        })
        window.electronAPI.onDnsChangeWarn((_, type) => {
          if (this.setting_data.never_show_dnc_warn) return
          let data = {
            config: {
              title: '检测到下载速度过慢',
              desc: '开启httpdsn开关可以提高下载速度',
              confirm: {
                text: '开启并重启'
              },
              cancel: {
                text: '我知道了'
              },
              neverShow: {
                text: '不再提示'
              },
              className: 'cpt-dns-warn-dialog', // cpt-dns-warn-dialog的层级是10000，因为更新弹窗的层级是写死9999，需要在更新弹窗只上
            },
            confirmCB: ({is_never_show}) => {
              this.SET_SETTING_DATA_PARAM({
                never_show_dnc_warn: is_never_show,
                dns_rewrite: 'ali'
              })
              setTimeout(() => {
                window.electronAPI.restartApp()
              }, 100)
            },
            cancelCB: ({is_never_show}) => {
              if (is_never_show) {
                this.SET_SETTING_DATA_PARAM({
                  never_show_dnc_warn: is_never_show
                })
              }
            },
          }
          if (type === 'media') {
            data.config.title = '检测到语音包加载失败'
          }
          if (process.env.IS_CLIENT) {
            window.electronAPI.focusWindow()
          }
          this.$query(data)
          setTimeout(() => {
            let modal = document.querySelector('.v-modal')
            if (modal) {
              // 需要更新蒙层的层级为9999，因为更新弹窗的层级是写死9999，modal需要在更新弹窗之上
              modal.style.zIndex = '9999'
            }
          })
        })
      }
    },
    async initMachineId() {
      if(process.env.IS_CLIENT && window.electronAPI) {
        const device_id = await getMachineId()
        this.SET_DEVICE_ID(device_id)
      }
    },
    setReport() {
      setTimeout(() => {
        window.electronAPI.sendReport('memory', {
          type: 'startup_1min'
        }, 'day')
      }, 1 * 60 * 1000)
      setTimeout(() => {
        window.electronAPI.sendReport('memory', {
          type: 'startup_30min'
        }, 'day')
      }, 30 * 60 * 1000)
    },
    preventDefaultContextMenu(event) {
      const disabledClasss = ['el-image-viewer__mask', 'disabled-prevent-contextmenu']
      if (disabledClasss.some(v => event.target.classList.contains(v))) {
        return false
      }
      return true
    },
    async getCurrentVersionLog () {
      let params = {
        client_version: ''
      }
      let version
      if (process.env.IS_CLIENT) {
        version = await window.electronAPI.getClientVersion()
        params.client_version = version.client_version
        params.asar_version = version.asar_version
        this.SET_VERSION_INFO(version)
      }
      getCurrentVersionLog(params).then((res) => {
        if (res.data.status === 'ok') {
          let d = res.data.result
          EventBus.$dynamic('UpdateDialog', { dialogData: d, onlyShowLogs: true, isCurrentVersion: true })
        }
      })
    },
    async getUpdateUrl() {
      let params = {
        client_version: ''
      }
      let version
      if (process.env.IS_CLIENT) {
        version = await window.electronAPI.getClientVersion()
        params.client_version = version.client_version
        params.asar_version = version.asar_version 
        this.asar_version = version.asar_version
        this.SET_VERSION_INFO(version)

        this.rollBackCount = await window.electronAPI.getRollBackCount()
        this.asarDownloadStatus = await window.electronAPI.getAsarDownloadStatus()
      }
      getUpdateUrl(params).then((res) => {
        if (res.data.status === 'ok') {
          let d = res.data.result
          if (process.env.IS_CLIENT) {
            this.updateInfo = d
            this.updateClientHandler(version)
          } else {
            if (d.download_url) {
              this.SET_CLIENT_DOWNLOAD_URL(d.download_url)
            }
          }
        }
      })
    },
    async updateClientHandler (clientVersion) {
      let d = this.updateInfo
      if(this.rollBackCount >= 1) {
        this.updateInfo.operation_error = true
      }
      if(this.asarDownloadStatus == 1) {
        this.updateInfo.asar_has_downloaded = true
      }
      if (d.has_new_version) {
        if (d.force_update || d.need_update_exe || !clientVersion.edit_authority) {
          this.SET_HAS_NEW_VERSION(true)
          EventBus.$dynamic('UpdateDialog', { dialogData: this.updateInfo })
        } else if (d.asar_download_url || d.manifest) {
          let ignore_version = await getStorage('ignore_version')
          if (ignore_version === d.latest_version) {
            return
          }
          if(this.rollBackCount >= 1) {
            this.SET_HAS_NEW_VERSION(true)
            EventBus.$dynamic('UpdateDialog', { dialogData: this.updateInfo })
          } else if(this.asarDownloadStatus == 1) { // 用户因为登录刷新导致AsarDownloaded状态丢失
            this.SET_HAS_NEW_VERSION(true)
            this.SET_HAS_ASAR_DOWNLOADED(true)
          } else if (this.init_auto_update_asar == 1) {
            this.updateAsar(d)
          } else {
            this.SET_HAS_NEW_VERSION(true)
            EventBus.$dynamic('UpdateDialog', { dialogData: this.updateInfo, showTextBtn: true })
          }
        }
      } else {
        let version_update_logs = await getStorage('version_update_logs')
        if (version_update_logs === this.updateInfo.latest_version) {
          EventBus.$dynamic('UpdateDialog', { dialogData: this.updateInfo, onlyShowLogs: true })
        }
      }
    },
    updateAsar (d, needProgress) {
      window.electronAPI.updateAsarResource(
        d.latest_version,
        d.asar_download_url,
        d.manifest,
        (action, param) => {
          switch (action) {
            case 'success':
              if (needProgress) {
                EventBus.$emit('update_asar_progress', { type: 'success' })
                setTimeout(() => {
                  const relaunchApp = true
                  window.electronAPI.setAsarVersion(this.updateInfo.latest_version, relaunchApp)
                }, 200)
              } else {
                if (compareVersions(this.asar_version, this.updateInfo.tips_version) == -1) {
                  setStorage('version_update_logs', this.updateInfo.latest_version)
                  this.updateInfo.asar_has_downloaded = true
                  this.SET_HAS_NEW_VERSION(true)
                  this.SET_HAS_ASAR_DOWNLOADED(true)
                }
                const relaunchApp = false
                window.electronAPI.setAsarVersion(this.updateInfo.latest_version, relaunchApp)
              }
              break;
            case 'error':
              if (needProgress) {
                this.updateInfo.asar_error = true
                EventBus.$emit('update_exe_start')
              } else {
                this.updateInfo.asar_error = true
                this.SET_HAS_NEW_VERSION(true)
                EventBus.$dynamic('UpdateDialog', { dialogData: this.updateInfo })
              }
              break;
            case 'progress': 
              if (needProgress) {
                EventBus.$emit('update_asar_progress', param)
              }
              break;
            case 'extract':
              if (needProgress) {
                EventBus.$emit('update_asar_progress', { type: 'extract' })
              }
            default:
              break;
          }
        },
      )
    },
    showRelaunchAppDialog () {
      EventBus.$dynamic('UpdateDialog', { dialogData: this.updateInfo, showTextBtn: true, relaunchReady: true })
    },
    bindEvent() {
      EventBus.$on('Show_Update_Client', () => {
        if (this.updateInfo.asar_has_downloaded) {
          this.showRelaunchAppDialog()
        } else {
          this.updateInfo.cancel = '我知道了'
          EventBus.$dynamic('UpdateDialog', { dialogData: this.updateInfo })
        }
      })
      EventBus.$on('Start_Update_Asar', () => {
        this.updateAsar(this.updateInfo, true)
      })
      EventBus.$on('openImgPreviewer', (urlList, initialIndex, isLongImg) => {
        this.imgPreviewer = {
          show: true,
          initialIndex,
          urlList,
          isLongImg
        }
      })
      EventBus.$on('showClientVersionLogs', () => {
        this.getCurrentVersionLog()
      })
      EventBus.$on('Get_Update_Url', () => {
        this.getUpdateUrl()
      })
      EventBus.$on('Change_Overlay_Position_Setter_Show', (v) => {
        this.showOverlaySetter = v
      })
      EventBus.$on('SOCKET_MATCHING_SUCCESS', (data) => {
        if(process.env.IS_CLIENT && window.electronAPI) window.electronAPI.focusWindow()
        this.tip_sound_control(0) && playAudio(require('_audio/team-message.mp3'), this.tip_sound_volume)
        this.CLEAR_MATCH_INTERVAL()
        EventBus.$dynamic('MatchSuccessDialog', {
          match_params: this.match_params,
          data: data.data,
        })
      })

      EventBus.$on('Manual_Update_Asar', async (updateInfo, callback) => {
        this.updateInfo = updateInfo
        const version = await window.electronAPI.getClientVersion()
        this.updateClientHandler(version)
      })
    },
    imgPreviewerClose() {
      this.imgPreviewer = {
        show: false,
        initialIndex: 0,
        urlList: []
      }
    },
    ...mapActions([
      'SET_SETTING_DATA_PARAM',
    ]),
    ...mapMutations([
      'SET_CLIENT_DOWNLOAD_URL',
      'SET_VERSION_INFO',
      'SET_HAS_NEW_VERSION',
      'SET_HAS_ASAR_DOWNLOADED',
      'SET_USER_ACCOUNT_SETTINGS',
      'CLEAR_MATCH_INTERVAL',
      'SET_DEVICE_ID',
    ])
  }
}
</script>
<style lang="scss">
#app {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  min-width: 990px;

  &.login-page {
    background: url("https://imgheybox.max-c.com/oa/2023/09/15/eea5d780dcfc4a318ce2b09e8aeda8b8.png") no-repeat center/cover;
  }

  &.desktop {
    // border-radius: 8px;
    overflow: hidden;
    top: 30px;

    .app {
      height: 100%;
    }
  }
  &.setting-overlay {
    top: 0;
  }
}

.viewer-fade-enter-active {
  animation: viewer-fade-in .3s;
}

.viewer-fade-leave-active {
  animation: viewer-fade-out .3s;
}

@keyframes viewer-fade-in {
  0% {
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

@keyframes viewer-fade-out {
  0% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
}
</style>
